import { render, staticRenderFns } from "./editors.vue?vue&type=template&id=2892f044&scoped=true"
import script from "./editors.vue?vue&type=script&lang=js"
export * from "./editors.vue?vue&type=script&lang=js"
import style0 from "./editors.vue?vue&type=style&index=0&id=2892f044&prod&lang=less"
import style1 from "./editors.vue?vue&type=style&index=1&id=2892f044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2892f044",
  null
  
)

export default component.exports